export default __webpack_public_path__ + "static/other1-b8d924644d1e40697b056bcb72e3b14d.jpg";